/* eslint-disable react-native/no-inline-styles */
/**
 * AppLoader Component
 * 
 * Global loading indicator modal
 * - Shows full-screen loading overlay
 * - Controlled by Redux state (info.loader)
 * - Displays spinner with "Please Wait..." message
 * - Semi-transparent backdrop
 * 
 * @component
 */
import React from 'react';
import { Modal, StyleSheet, View } from 'react-native';
import { useSelector } from 'react-redux';
import { ActivityIndicator, Paragraph } from 'react-native-paper';
import { theme } from '../theme/theme';

const AppLoader = () => {
  const modalVisible = useSelector((state) => state.info?.loader);
  return (
    <Modal
      animationType="none"
      transparent={true}
      visible={modalVisible}>
      <View style={styles.centeredView}>
        <View style={styles.modalView}>
          <View style={{ flexDirection: 'row', alignItems: 'center' }}>
            <ActivityIndicator animating={true} color={theme.colors.primary} size={28} />
            <Paragraph style={{ marginLeft: 16 }}>Please Wait...</Paragraph>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.2)',
  },
  modalView: {
    margin: 20,
    backgroundColor: '#ffffff',
    borderRadius: 4,
    padding: 16,
    alignItems: 'center',
    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },
});

export default AppLoader;
